import Minus from "../../icons/Minus";
import Plus from "../../icons/Plus";
import styles from "./style.module.scss";
const Counter = ({
  count,
  setCount,
}: {
  count: number;
  setCount: (val: number) => void;
}) => {
  const changeCount = (addVal: number) => {
    if (count + addVal < 1 || count + addVal > 99) return;
    setCount(count + addVal);
  };
  return (
    <div className={styles.counterContainer}>
      <div
        className={`${styles.pressButton} ${count < 2 ? styles.disable : ""}`}
        onClick={() => changeCount(-1)}
      >
        <Minus />
      </div>
      <div className={styles.countBox}>{count}</div>
      <div
        className={`${styles.pressButton} ${count > 98 ? styles.disable : ""}`}
        onClick={() => changeCount(1)}
      >
        <Plus />
      </div>
    </div>
  );
};

export default Counter;
